import { useEffect, useRef } from 'react';
import { useRoomContext, useParticipants } from '@livekit/components-react';

const encode = (obj) => new TextEncoder().encode(JSON.stringify(obj));

const HostFilterBroadcaster = ({ socket }) => {
  const room = useRoomContext();
  const participants = useParticipants();
  const lastStandingsRef = useRef(null);

  useEffect(() => {
    if (!socket || !room) return undefined;
    const handler = (data) => {
      try {
        room.localParticipant.publishData(
          encode({
            type: 'filterState',
            standings: data.standings,
            transient: data.transient,
            round: data.round,
          }),
          { reliable: true }
        );
        if (data.standings) lastStandingsRef.current = data.standings;
      } catch (e) {
        console.error('HostFilterBroadcaster publishData failed:', e);
      }
    };
    socket.on('filter_states', handler);
    return () => socket.off('filter_states', handler);
  }, [socket, room]);

  // Re-publish last standings whenever the participant set changes so late /
  // reconnecting guests catch up; LiveKit data messages are not persisted.
  useEffect(() => {
    if (!room || !lastStandingsRef.current) return;
    try {
      room.localParticipant.publishData(
        encode({
          type: 'filterState',
          standings: lastStandingsRef.current,
          transient: {},
        }),
        { reliable: true }
      );
    } catch (_) {
      /* room may be tearing down — ignore */
    }
  }, [room, participants.length]);

  return null;
};

export default HostFilterBroadcaster;
